import CheckIcon from '@mui/icons-material/Check'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline'
import ScheduleIcon from '@mui/icons-material/Schedule'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Grid, Typography } from '@mui/material'
import { ConnectionStatus } from 'honeygrid-types/validators-and-types/ConnectionTypes'

import type { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'
import type { FC } from 'react'

interface ConnectionCardStatusRowProps {
	connection: Connection
}

const ConnectionStatusStringMap: Record<ConnectionStatus, string> = {
	[ConnectionStatus.Active]: 'Active',
	[ConnectionStatus.Pending]: 'Pending Setup',
	[ConnectionStatus.Inactive]: 'Inactive',
	[ConnectionStatus.Expired]: 'Credentials Expired',
	[ConnectionStatus.Error]: 'Error',
}

export const ConnectionCardStatusRow: FC<ConnectionCardStatusRowProps> = ({ connection }) => {
	const icons: Record<ConnectionStatus, React.ReactNode> = {
		[ConnectionStatus.Active]: <CheckIcon color="success" fontSize="small" />,
		[ConnectionStatus.Pending]: <ScheduleIcon color="warning" fontSize="small" />,
		[ConnectionStatus.Inactive]: <PauseCircleOutlineIcon color="disabled" fontSize="small" />,
		[ConnectionStatus.Expired]: <WarningAmberIcon color="warning" fontSize="small" />,
		[ConnectionStatus.Error]: <ErrorOutlineIcon color="error" fontSize="small" />,
	}

	return (
		<Grid container display="flex" alignItems="center">
			{icons[connection.status]}
			<Typography variant="body2" component="p" sx={{ marginLeft: '8px' }}>
				{ConnectionStatusStringMap[connection.status]}
			</Typography>
		</Grid>
	)
}
